<template>
  <div class="wwf-richmond-fc-form">
    <div class="petition-counter" v-if="showcounter">
      <h2>
        <count-to
          ref="counter"
          :startVal="startcounter"
          :end-val="endcounter"
          :autoplay="false"
          :duration="7000"
        ></count-to>
      </h2>
      <h5>{{countertitle}}</h5>
    </div>

    <div v-if="isActive" class="petition-form wwf-form light">
      <div class="flip-wrapper" :class="{ 'formValidation-shake' : isShake }">
        <div class="petition-form">
          <h3 class="form-intro">{{title}}</h3>

          <p class="form-intro">
            <span v-html="intro"></span>
          </p>

          <div>
            <div class="small-12 medium-6 columns left-field field-title">
              <div class="field" :class="this.firstName ? 'has-content' : ''">
                <input
                  name="firstName"
                  type="text"
                  v-model="firstName"
                  v-validate="{ required: true}"
                  :class="{'border-red': errors.has('firstName')}"
                >
                <label
                  for="firstName"
                >Parent's First name</label>
              </div>
            </div>

            <div class="small-12 medium-6 columns right-field field-title">
              <div class="field" :class="this.lastName ? 'has-content' : ''">
                <input
                  name="lastName"
                  type="text"
                  v-model="lastName"
                  v-validate="{ required: true}"
                  :class="{'border-red': errors.has('lastName')}"
                >
                <label
                  for="lastName"
                >Parent's surname</label>
              </div>
            </div>

            <div class="small-12 medium-6 columns left-field field-title">
              <div class="field" :class="this.childFirstName ? 'has-content' : ''">
                <input
                  name="childFirstName"
                  type="text"
                  v-model="childFirstName"
                  v-validate="{ required: true}"
                  :class="{'border-red': errors.has('childFirstName')}"
                >
                <label
                  for="childFirstName"
                >Child's First name</label>
              </div>
            </div>

            <div class="small-12 medium-6 columns right-field field-title">
              <div class="field" :class="this.childLastName ? 'has-content' : ''">
                <input
                  name="childLastName"
                  type="text"
                  v-model="childLastName"
                  v-validate="{ required: true}"
                  :class="{'border-red': errors.has('childLastName')}"
                >
                <label
                  for="childLastName"
                >Child's surname</label>
              </div>
            </div>

            <div class="small-12 medium-6 columns left-field field-title">
              <div class="field" :class="this.childDob ? 'has-content' : ''">
                <datepicker
                  :disabledDates="disabledFn"
                  name="childDob"
                  v-validate="'required'"
                  :minimumView="'day'"
                  :format="'dd/MM/yyyy'"
                  :input-class="{'border-red': errors.has('childDob')}"
                  v-model="childDob"
                  :maximumView="'year'"
                  :initialView="'day'"
                ></datepicker>
                <label for="childDob">
                  Child's D.O.B
                  <i
                    class="far fa-calendar-alt"
                  ></i>
                </label>
              </div>
            </div>

            <div class="small-12 medium-6 columns right-field field-title">
              <div class="field" :class="this.postCode ? 'has-content' : ''">
                <input
                  name="postCode"
                  type="number"
                  v-model="postCode"
                  v-validate="{ required: true}"
                  :class="{'border-red': errors.has('postCode')}"
                >
                <label for="postCode">Postcode</label>
              </div>
            </div>

            <div class="small-12 medium-6 columns left-field field-title">
              <div class="field" :class="this.email ? 'has-content' : ''">
                <input
                  name="email"
                  type="email"
                  v-model="email"
                  v-validate="{ required: true, email: true}"
                  :class="{'border-red': errors.has('email')}"
                >
                <label for="email">Email</label>
              </div>
            </div>

            <div class="small-12 medium-6 columns right-field field-title">
              <div class="field" :class="this.phone ? 'has-content' : ''">
                <input
                  name="phone"
                  type="number"
                  min="8"
                  max="12"
                  v-model="phone"
                  v-validate="{ required: true}"
                  :class="{'border-red': errors.has('phone')}"
                >
                <label for="phone">Mobile</label>
              </div>
            </div>

            <div class="small-12 medium-12 columns field-title">
              <textarea
                name="message"
                :placeholder="messageplaceholder"
                v-model="message"
                maxlength="255"
                v-validate="{required:true}"
                :class="{'border-red': errors.has('message')}"
              ></textarea>
              <p
                class="word-count"
              >{{ 255 - (message ? message.length : 0) + ' Char' }}</p>
            </div>

            <div class="privacy-statement small-12 medium-12 columns field-title">
              <p>
                By signing you accept
                <a
                  href="/privacy-policy/privacy-policy"
                  target="_blank"
                >WWF-Australia&rsquo;s Privacy Policy.</a>
              </p>
            </div>
            <input type="button" v-on:click="save" value="Submit">

            <span class="alert-box" v-show="isProfanity">No bad words! Please change your message.</span>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!isActive" class="form-closed">
      <p>{{closingmessage}}</p>
    </div>
  </div>
</template>

<script>
import countTo from "vue-count-to";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

const { detect } = require("detect-browser");
const browser = detect();

export default {
  components: { countTo, Datepicker },
  name: "wwfRichmondFcForm",
  created: function() {
    if (this.showcounter) {
      this.$store.dispatch("getCounterByCampaignId", this.datalayername);
    }
  },
  mounted: function() {
    if (this.showcounter) {
      console.log(this.$refs.counter);
      this.$refs.counter.start();
    }
  },
  computed: {
    endcounter: function() {
      return this.$store.getters.counter ? this.$store.getters.counter : 0;
    }
  },
  watch: {
    // use the watch to react on the value change.
    endcounter(newValue) {
      if (this.showcounter) {
        this.startcounter = newValue;
        this.$refs.counter.start();
        console.log("newValue", newValue);
      }
    }
  },
  props: {
    isActive: {
      //:is-active="false"
      type: Boolean,
      required: true
    },
    title: {
      //thankyoutitle="Test title"
      type: String,
      required: true
    },
    intro: {
      //intro="Test intro"
      type: String,
      required: true
    },
    thankyoutitle: {
      //thankyoutitle="Test thankyou title"
      type: String,
      required: true
    },
    thankyoumessage: {
      //thankyoumessage="Test thankyou message"
      type: String,
      required: true
    },
    datalayername: {
      //datalayername="Test datalayer name"
      type: String,
      required: true
    },
    closingmessage: {
      //closingmessage="Test the compatition has closed."
      type: String,
      default: "This petition has now closed."
    },
    programname: {
      //petitionname="Test petition name"
      type: String,
      required: true
    },
    showcounter: {
      //showcounter="true"
      type: Boolean,
      default: true
    },
    countertitle: {
      //countertitle="Test message sent"
      type: String,
      default: "message sent"
    },
    messageplaceholder: {
      //countertitle="Test message placeholder"
      type: String,
      default: "Message"
    }
  },
  data: function() {
    return {
      startcounter: 0,
      firstName: "",
      lastName: "",
      childFirstName: "",
      childLastName: "",
      childDob: null,
      phone: "",
      email: "",
      postCode: "",
      message: "",
      isProfanity: false,
      isShake: false,
      disabledFn: {
        customPredictor: function(date) {
          if (moment().isBefore(date, "day")) {
            return true;
          }
        }
      }
    };
  },
  methods: {
    save: function() {
      var postBody = {
        email: this.email,
        firstName: this.firstName,
        lastName: this.lastName,
        childFirstName: this.childFirstName,
        childLastName: this.childLastName,
        childDob: moment(this.childDob).format('YYYY-MM-DD'),
        phone: this.phone,
        postcode: this.postCode,
        programName: this.programname,
        childmessage: this.message ? this.message : "",
        cookieID: this.$cookie.get("_mkto_trk"),
        keepData: true
      };

      if (browser) {
        postBody.browsername = browser.name;
        postBody.browserversion = browser.version;
        postBody.browseros = browser.os;
      }

      console.log(postBody);

      this.$validator.validate().then(result => {
        if (result) {
            this.$http
              .jsonp(
                "https://api1.webpurify.com/services/rest/?api_key=b7c6af7e5259ce74f099897deb9dcf29&method=webpurify.live.check&text=" +
                  encodeURIComponent(postBody.childmessage) +
                  "&format=json"
              )
              .then(response => {
                if (response.data) {
                  this.isProfanity = response.data.rsp.found != "0";
                  if (!this.isProfanity) {
                    console.log("Message clean");
                    this.saveLead(postBody);
                  } else {
                    console.log("Message not clean");
                  }
                }
              });
        } else {
          console.log("form invalid");
          // GTM Tracking
          if (window.dataLayer != undefined) {
            window.dataLayer.push({
              formName: this.datalayername,
              event: "formSubmitEvent"
            });
          }
          this.isShake = true;
          setTimeout(
            function() {
              this.isShake = false;
            }.bind(this),
            500
          );
        }
      });
    },
    saveLead: function(postBody) {
      this.$store
        .dispatch("saveLead", {
          campaignId: this.datalayername,
          lead: postBody
        })
        .then(
          response => {
            console.log("petition submit success");

            if (window.dataLayer != undefined) {
              window.dataLayer.push({
                formName: this.datalayername,
                event: "formSubmitSuccessEvent"
              });
            }

            //Reset form
            this.firstName = "";
            this.lastName = "";
            this.childFirstName = "";
            this.childLastName = "";
            this.childDob = null;
            this.phone = "";
            this.email = "";
            this.postCode = "";
            this.message = "";
          },
          error => {
            console.error("Petition submit failed");
          }
        );
      this.$store.commit("setPopupContent", {
        title: this.thankyoutitle,
        message: this.thankyoumessage,
        shareButton: true,
        recommendedReading: false,
        component: null,
        componentparams: null
      });
      this.$store.commit("openPetitionPopup", true);
    }
  }
};
</script>

<style>
.wwf-richmond-fc-form .field {
  position: relative;
}
.wwf-richmond-fc-form .field label {
  position: absolute;
  z-index: 3;
  top: 0;
  left: 10px;
  pointer-events: none;
  transform: translateY(12px);
  font-size: 16px;
  line-height: normal;
  transform-origin: top left;
  width: auto;
  padding: 0;
}
.wwf-richmond-fc-form .field input:focus ~ label,
.wwf-richmond-fc-form .field.has-content label,
.wwf-richmond-fc-form .field.select-label label {
  position: absolute;
  z-index: 3;
  top: 0;
  left: 10px;
  pointer-events: none;
  transform: translateY(3px) scale(0.75);
  font-size: 18px;
  line-height: normal;
  opacity: 0.5;
}

input[type="date"],
.has-content input[type="date"] ~ label {
  color: var(--wwfWhite);
}
.has-content input[type="date"],
input[type="date"]:focus {
  color: var(--wwfGrey47);
}

.wwf-richmond-fc-form input[type="text"],
.wwf-richmond-fc-form input[type="tel"],
.wwf-richmond-fc-form input[type="email"],
.wwf-richmond-fc-form input[type="number"],
.wwf-richmond-fc-form input[type="date"],
.wwf-richmond-fc-form textarea {
  background-color: rgba(0, 0, 0, 0.05);
  border: 0;
  border-radius: 7px;
  box-shadow: inset 0 0 0 1px rgba(220, 220, 220, 0);
  cursor: pointer !important;
  height: 45px;
  padding: 15px 10px 0 10px;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 1em;
}
</style>


// WEBPACK FOOTER //
// wwfRichmondFcForm.vue?d0b76018